export const LOADING_DISCIPLINARY_ACTION_TYPES = "LOADING_DISCIPLINARY_ACTION_TYPES";
export const SAVE_LOADING_DISCIPLINARY_ACTION_TYPES = "SAVE_LOADING_DISCIPLINARY_ACTION_TYPES";
export const GET_DISCIPLINARY_ACTION_TYPES = "GET_DISCIPLINARY_ACTION_TYPES";
export const FORM_FAIL = "FORM_FAIL";
export const DISCIPLINARY_ACTION_TYPES_FAIL = "DISCIPLINARY_ACTION_TYPES_FAIL";

